<template>
  <div>
    <div class="row justify-content-center text-left">
      <user-provider-feed
        v-for="item in getProvider"
        v-bind:key="item.id"
        :provider="item"
        v-on:startAddProvider="onstartAddProvider"
      />
    </div>
    <transition name="no-mode-translate-fade">
      <user-menu-add v-if="selectedProvider==1" @executeStop="$emit('executeStop')"/>
    </transition>
    <transition name="no-mode-translate-fade">
      <provider-bitcoin v-if="selectedProvider==2" @executeStop="$emit('executeStop')"/>
    </transition>
  </div>
</template>

<script>
import UserProviderFeed from "./Provider/UserProviderFeed.vue";
import UserMenuAdd from "./User.Menu.Add.vue";
import ProviderBitcoin from "./Provider/ProviderBitcoin.vue";

export default {
  name: "UserMenuProvider",
  components: {
    UserProviderFeed,
    UserMenuAdd,
    ProviderBitcoin
  },
  data: function() {
    return {
      selectedProvider: -1,
      provider: [
        {
          id: 1,
          title: "Feed hinzufügen",
          text: "Eine neue Feed-Quelle hinzufügen",
          img: "img/feed.jpg",
          btnText: "Feed hinzufügen",
          btnIcon: "fas fa-rss"
        },
        {
          id: 2,
          title: "Kryptowährung",
          text: "Zeigt den Kurs vieler Kryptowährungen in Euro an",
          img: "img/bitcoin.jpg",
          btnText: "Kryptowährung hinzufügen",
          btnIcon: "fab fa-btc"
        }
      ]
    };
  },
  computed: {
    getProvider: function() {
      if (this.selectedProvider > 0) return [];
      else return this.provider;
    }
  },
  methods: {
    onstartAddProvider: function(providerId) {
      this.selectedProvider = providerId;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-mode-translate-fade-enter-active,
.no-mode-translate-fade-leave-active {
  transition: all 0.1s;
}
.no-mode-translate-fade-enter,
.no-mode-translate-fade-leave-active {
  opacity: 0;
}
.no-mode-translate-fade-enter {
  transform: translateX(31px);
}
.no-mode-translate-fade-leave-active {
  transform: translateX(-31px);
}
</style>
